import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-facebook',
    templateUrl: './facebook.component.html',
    styleUrls: ['./facebook.component.scss'],
    standalone: true
})
export class FacebookComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
